module.exports = __webpack_public_path__ + "img/esterilizacion.7b2a6697.png";